import Vue from 'vue'
import VueRouter from 'vue-router'
import IndexHome from '../views/index.vue'
import Monitoring from '../views/other/monitoring.vue'
import Board from '../views/other/board.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: IndexHome,
     meta: { title: '智慧电梯物联网管理平台' }
  },
  {
    path: '/monitoring',
    name: 'monitoring',
    component: Monitoring,
     meta: { title: '智慧电梯无纸化平台' }
  },
  {
    path: '/board',
    name: 'board',
    component: Board,
     meta: { title: '首页' }
  }
]

const router = new VueRouter({
  routes
})

export default router
